import useTranslation from '../../hooks/useTranslation';
import { Fragment } from 'react';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import PrimaryButton from 'components/buttons/PrimaryButton';
import SecondaryButton from 'components/buttons/SecondaryButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, ModalState, Props, ReactElement } from './types';

import styles from './styles.module.scss';

const JohnDeereExportModalFooter: FunctionComponent<Props> = ({
    isPickerReady,
    onCancel,
    onConfirmExport,
    onRetry,
    state,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    const footerByKind: Record<ModalState['kind'], () => ReactElement> = {
        autoResolved: () => <PrimaryButton onClick={onConfirmExport} text={t.EXPORT_BUTTON} />,
        error: () => (
            <Fragment>
                <SecondaryButton onClick={onCancel} text={t.CANCEL_BUTTON} />

                <PrimaryButton onClick={onRetry} text={t.RETRY_BUTTON} />
            </Fragment>
        ),
        exporting: () => (
            <PrimaryButton isDisabled={true} onClick={onCancel} text={t.EXPORT_BUTTON} />
        ),
        needsPicker: () => (
            <PrimaryButton
                isDisabled={!isPickerReady}
                onClick={onConfirmExport}
                text={t.EXPORT_BUTTON}
            />
        ),
        resolving: () => <SecondaryButton onClick={onCancel} text={t.CANCEL_BUTTON} />,
        success: () => <PrimaryButton onClick={onCancel} text={t.CLOSE_BUTTON} />
    };

    return (
        <HorizontalContainer className={styles.johnDeereExportModalFooter} testId={testId}>
            {footerByKind[state.kind]()}
        </HorizontalContainer>
    );
};

export default JohnDeereExportModalFooter;
